import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  type?: string
  message?: string
}
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    type: { default: '' },
    message: { default: '' }
  },
  setup(__props: any) {

const props = __props as { type: string, message: string }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`alert ${props.type}`)
  }, [
    _createElementVNode("div", null, _toDisplayString(props.message), 1)
  ], 2))
}
}

})